import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterSeatsValueObject extends ValueObject {
  #label
  #seats

  constructor({seats, label}) {
    super()
    this.#seats = seats
    this.#label = label
  }

  static validate({seats, label}) {
    if (seats === undefined || seats === null) {
      throw InvalidParamsSharedError.create({message: 'Seats is required'})
    }
  }

  static create({seats, label}) {
    FilterSeatsValueObject.validate({seats, label})
    return new FilterSeatsValueObject({
      label: StringSharedValueObject.create({value: label}),
      seats: FilterIdsArraySearchValueObject.createForNumbers({value: seats})
    })
  }

  get isEmpty() {
    return this.#seats.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#seats.queryParam})
    }
  }

  get label() {
    return this.#label.value
  }

  get seats() {
    return this.#seats.value
  }

  get value() {
    return {
      label: this.label,
      seats: this.seats
    }
  }

  toJSON() {
    return {
      seats: this.#seats.toJSON()
    }
  }
}
